import { render } from "./CurrencyRateForm.vue?vue&type=template&id=c61ea222&ts=true"
import script from "./CurrencyRateForm.vue?vue&type=script&lang=ts"
export * from "./CurrencyRateForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__